import { LifeBuoy, LogOut, UserCog } from 'lucide-react';
import { useParams } from 'react-router';

import { Command } from '@components/features/CommandMenu/Command';
import { usePlain } from '@components/features/Plain';
import { useAuth0 } from '@hooks/useAuth0';
import { useUserQuery } from '@queries/user';

export function UserCommands() {
  const Plain = usePlain();
  const { teamUuid } = useParams();
  const { data: user } = useUserQuery();
  const { logout } = useAuth0();

  if (!user) return null;

  return (
    <>
      <Command
        type="route"
        id="user-settings"
        label="Settings"
        context="user"
        group={user.name}
        icon={<UserCog />}
        href={`/${teamUuid}/settings`}
        keywords={['settings', 'account', 'profile']}
      />

      {Plain.isReady && (
        <Command
          type="action"
          id="help-support"
          label="Help & support"
          context="user"
          group={user.name}
          icon={<LifeBuoy />}
          onSelect={Plain.show}
          keywords={['plain', 'chat']}
        />
      )}

      <Command
        type="action"
        id="sign-out"
        label="Sign out"
        context="user"
        group={user.name}
        icon={<LogOut />}
        onSelect={() => logout()}
        keywords={['log out']}
      />
    </>
  );
}
